import Totals from '../../PackingListFormComponents/Totals';
import SignatureDetails from '../../PackingListFormComponents/SignatureDetails';
import { PackingListInterface } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/parkinglistTypes';

const StepThree = ({
    updateField,
    payload,
    setShowAddPartner,
    errors,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalNetWeight,
    totalUnitQuantity,
    totalGrossWeight,
    totalVolume
}: PackingListInterface) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <Totals
                {...{
                    totalNetWeight,
                    totalUnitQuantity,
                    totalGrossWeight,
                    totalVolume
                }}
            />
            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
            <SignatureDetails
                {...{
                    errors,
                    payload,
                    setSignatureUrlBase64,
                    updateField,
                    signatureUrlBase64,
                    setShowAddPartner
                }}
            />
        </div>
    );
};

export default StepThree;
